var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav"},[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.facebook.com/VoltadoLagoCaixa/"}},[_c('i',{staticClass:"fa fa-facebook"})])]),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://instagram.com/voltadolagocaixa/"}},[_c('i',{staticClass:"fa fa-instagram"})])])])
}]

export { render, staticRenderFns }